import script from "./BACS-Questionnaire-Step5.vue?vue&type=script&setup=true&lang=js"
export * from "./BACS-Questionnaire-Step5.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__